import {
  getHoverableLinkCSS,
  HoverableLink as SharedHoverableLink,
  HoverableLinkProps as SharedHoverableLinkProps,
} from '@paywithextend/components'
import { Location } from 'history'
import React from 'react'
import Lnk, { AriaProps } from 'src/navigation/Lnk'
import { LocationState } from 'src/redux/createRootReducer'

export type HoverableLinkProps = SharedHoverableLinkProps &
  AriaProps & { to?: Location<LocationState> | string }

const HoverableLink: React.FC<React.PropsWithChildren<HoverableLinkProps>> = (
  props,
): React.ReactElement => {
  const linkProps = {
    className: props.className,
    id: props.id,
    onClick: props.onClick,
  }

  const designProps = {
    size: props.size,
    design: props.design,
    underline: props.underline,
    hoverUnderline: props.hoverUnderline,
    regular: props.regular,
    disabled: props.disabled,
    colorSvgOnHover: props.colorSvgOnHover,
    loading: props.loading,
  }

  const ariaProps =
    props.ariaLabelSource !== undefined
      ? { ariaLabelSource: props.ariaLabelSource }
      : { ariaLabel: props.ariaLabel }

  return props.to !== undefined ? (
    <Lnk
      to={props.to}
      {...linkProps}
      {...ariaProps}
      testId={props.testId}
      css={
        // @ts-ignore - properly handle partial designProps
        getHoverableLinkCSS(designProps)
      }
    >
      {props.children}
    </Lnk>
  ) : (
    // TODO: apply hover styles to on focus as well
    <SharedHoverableLink
      {...linkProps}
      {...designProps}
      {...ariaProps}
      href={props.href}
      testId={props.testId}
    >
      {props.children}
    </SharedHoverableLink>
  )
}

export default HoverableLink
